"use strict";
/**
 * Error-related type definitions
 * Error codes follow RESOURCE_ACTION_REASON format
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=error.js.map